//import api from "./api";
// @ts-nocheck

import useStore from "../store/useStore";

export enum LogEventType {
  LOGIN = "LOGIN",
  LOGOUT = "LOGOUT",
  PAGE_VIEW = "PAGE_VIEW",
  NAVIGATION = "NAVIGATION",
  SIDEBAR_CLICK = "SIDEBAR_CLICK",
  ERROR = "ERROR",
  USER_ACTION = "USER_ACTION",
  FORM_SUBMIT = "FORM_SUBMIT",
}

class LoggingService {
  async logEvent(eventType: LogEventType, eventData: any = {}) {
    const user = useStore.getState().user;
    if (!user) return;

    const logData = {
      eventType,
      eventData,
      pageUrl: window.location.pathname,
      timestamp: new Date().toISOString(),
      userInfo: {
        name: user.nome,
        roles: user.role,
      },
    };

    try {
      // await api.post("/logs", logData);
    } catch (error) {
      console.error("Erro ao enviar log:", error);
    }
  }

  async logLogin() {
    const user = useStore.getState().user;
    await this.logEvent(LogEventType.LOGIN, { userName: user?.nome });
  }

  async logLogout() {
    const user = useStore.getState().user;
    await this.logEvent(LogEventType.LOGOUT, { userName: user?.nome });
  }

  async logNavigation(from: string, to: string) {
    await this.logEvent(LogEventType.NAVIGATION, { from, to });
  }

  async logSidebarClick(itemName: string, itemPath: string) {
    await this.logEvent(LogEventType.SIDEBAR_CLICK, {
      item: itemName,
      path: itemPath,
    });
  }

  async logError(error: Error, context: string) {
    await this.logEvent(LogEventType.ERROR, {
      message: error.message,
      stack: error.stack,
      context,
    });
  }

  async logFormSubmit(formName: string, success: boolean, data?: any) {
    await this.logEvent(LogEventType.FORM_SUBMIT, {
      form: formName,
      success,
      data,
    });
  }
}

export default new LoggingService();
